"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoData = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
/**
 * @internal
 */
exports.NoData = function (_a) {
    var className = _a.className, hasNoMatchingData = _a.hasNoMatchingData, notFoundLabel = _a.notFoundLabel, noDataLabel = _a.noDataLabel;
    var classNames = classnames_1.default("gd-no-data", {
        "gd-no-matching-data": hasNoMatchingData,
        "gd-no-data-available": !hasNoMatchingData,
    }, className);
    return react_1.default.createElement("div", { className: classNames }, hasNoMatchingData ? notFoundLabel : noDataLabel);
};
//# sourceMappingURL=NoData.js.map